module.exports = __webpack_public_path__ + "static/Michael-Mueller-Registered-Representative-Coastal-Advisory-Group_480px-7c7e81f0da77ea178c20cce24abadb22.png";